module.exports = __webpack_public_path__ + "static/media/007.1a8cb5f3.jpg";